import { StoreUtils } from './util';
import { UserUtils } from './auth';
import { SIDEBAR_MENU } from './constants';

export const REPORT_STAFF_ACCESS_READ_KEYS = {
  // Stock Reports
  BATCHWISE_STOCK_READ: 'batchWiseStockRead',
  OPENING_STOCK_READ: 'openingStockRead',
  EXPIRY_REPORT_READ: 'expiryReportRead',
  STOCK_ADJUSTMENT_READ: 'stockAdjustmentRead',
  NON_MOVING_READ: 'noMovingRead',
  ITEM_MAPPING_READ: 'itemMappingRead',
  LOW_STOCK_READ: 'lowStockRead',
  ITEM_MASTER_READ: 'itemMasterRead',
  SCHEDULE_REPORT_READ: 'scheduleReportRead',
  NEW_ITEM_READ: 'newItemRead',
  ITEMWISE_REPORT_READ: 'itemwiseReportRead',
  BOUNCE_ITEM_READ: 'bounceItemRead',
  STOCK_AUDIT_READ: 'stockAuditRead',
  ENQUIRY_READ: 'enquiryRead',
  // Sales report
  OVERSOLD_REPORT_READ: 'oversoldReportRead',
  ITEMWISE_SALES_MARGIN_READ: 'itemwiseSalesMarginRead',
  BATCHWISE_SALES_READ: 'batchwiseSalesRead',
  ITEMWISE_SALES_READ: 'itemwiseSalesRead',
  STAFFWISE_SALES_READ: 'staffwiseSalesRead',
  SALESPERSON_INCENTIVE_READ: 'incentiveRead',
  SHIFT_MANAGEMENT_READ: 'shiftManagementRead',
  // Purchase Reports
  BATCHWISE_PURCHASE_READ: 'batchwisePurchaseRead',
  OVERBOUGHT_READ: 'overboughtRead',
  DAILY_SUMMARY_READ: 'dailySummaryRead',
  SUPPLIER_DUE_DATE_READ: 'supplierDueDate',
  // GST reports
  GSTR_SALES_READ: 'gstSalesRead',
  GSTR_PURCHASE_READ: 'gstrPurchaseRead',
  GSTR_1_READ: 'gstr1Read',
  GSTR_2A_READ: 'gstr2aRead',
  GSTR_3B_READ: 'gstr3bRead',
  // WMS Reports
  BRANCH_PO_READ: 'branchPORead',
  GRN_HISTORY_READ: 'grnHistoryRead',
  FKH_REPORT_READ: 'fkhReportRead',
  // Tally Reports
  TALLY_MASTER_READ: 'tallyMasterRead',
  TALLY_TRANSACTION_READ: 'tallyTransactionRead',
};

export const REPORT_STAFF_ACCESS_DOWNLOAD_KEYS = {
  // Stock Reports
  BATCHWISE_STOCK_DOWNLOAD: 'batchWiseStockDownload',
  OPENING_STOCK_DOWNLOAD: 'openingStockDownload',
  EXPIRY_REPORT_DOWNLOAD: 'expiryReportDownload',
  STOCK_ADJUSTMENT_DOWNLOAD: 'stockAdjustmentDownload',
  NON_MOVING_DOWNLOAD: 'nonMovingDownload',
  ITEM_MAPPING_DOWNLOAD: 'itemMappingDownload',
  LOW_STOCK_DOWNLOAD: 'lowStockDownload',
  ITEM_MASTER_DOWNLOAD: 'itemMasterDownload',
  SCHEDULE_REPORT_DOWNLOAD: 'scheduleReportDownload',
  NEW_ITEM_DOWNLOAD: 'newItemDownload',
  ITEMWISE_REPORT_DOWNLOAD: 'itemwiseReportDownload',
  BOUNCE_ITEM_DOWNLOAD: 'bounceItemDownload',
  STOCK_AUDIT_DOWNLOAD: 'stockAuditDownload',
  ENQUIRY_DOWNLOAD: 'enquiryDownload',
  // Sales report
  OVERSOLD_REPORT_DOWNLOAD: 'oversoldReportDownload',
  ITEMWISE_SALES_MARGIN_DOWNLOAD: 'itemwiseSalesMarginDownload',
  BATCHWISE_SALES_DOWNLOAD: 'batchwiseSalesDownload',
  ITEMWISE_SALES_DOWNLOAD: 'itemwiseSalesDownload',
  STAFFWISE_SALES_DOWNLOAD: 'staffwiseSalesDownload',
  SALESPERSON_INCENTIVE_DOWNLOAD: 'incentiveDownload',
  SHIFT_MANAGEMENT_DOWNLOAD: 'shiftManagementDownload',
  // Purchase Reports
  BATCHWISE_PURCHASE_DOWNLOAD: 'batchwisePurchaseDownload',
  OVERBOUGHT_DOWNLOAD: 'overboughtDownload',
  DAILY_SUMMARY_DOWNLOAD: 'dailySummaryDownload',
  SUPPLIER_DUE_DATE_DOWNLOAD: 'supplierDueDateDownload',
  // GST reports
  GSTR_SALES_DOWNLOAD: 'gstSalesDownload',
  GSTR_PURCHASE_DOWNLOAD: 'gstrPurchaseDownload',
  GSTR_1_DOWNLOAD: 'gstr1Download',
  GSTR_2A_DOWNLOAD: 'gstr2aDownload',
  GSTR_3B_DOWNLOAD: 'gstr3bDownload',
  // WMS Reports
  BRANCH_PO_DOWNLOAD: 'branchPODownload',
  GRN_HISTORY_DOWNLOAD: 'grnHistoryDownload',
  FKH_REPORT_DOWNLOAD: 'fkhReportDownload',
  // Tally Reports
  TALLY_MASTER_DOWNLOAD: 'tallyMasterDownload',
  TALLY_TRANSACTION_DOWNLOAD: 'tallyTransactionDownload',
};

export const ACCESS_CONTROL_KEYS_ENUM = {
  BILL_READ: 'billRead',
  BILL_WRITE: 'billWrite',
  BILL_EDIT: 'billEdit',
  BILL_DELETE: 'billDelete',
  BILL_DISCOUNT: 'billDiscount',
  BILL_WHATSAPP: 'billWhatsapp',
  BILL_DATE: 'billDate',
  ENABLE_SALES_ORDER: 'enableSalesOrder',
  BILL_HISTORY_FOOTER_READ: 'billHistoryFooterRead',
  SALE_REPORT_DOWNLOAD: 'saleReportDownload',
  BILLED_ITEMS_EDIT: 'billedItemsEdit',
  CUSTOMER_DETAILS_EDIT: 'customerDetailsEdit',
  SALES_RETURN_READ: 'salesReturnRead',
  SALES_RETURN_WRITE: 'salesReturnWrite',
  SALES_RETURN_EDIT: 'salesReturnEdit',
  SALES_PAYMENT_MODE: 'salesPaymentMode',
  ONLINE_ORDER_READ: 'onlineOrderRead',
  CUSTOMER_READ: 'customerRead',
  DOCTOR_READ: 'doctorRead',
  PAYMENT_READ: 'paymentRead',
  PURCHASE_ORDER: 'purchaseIntegration',
  PURCHASE_READ: 'purchaseRead',
  PURCHASE_WRITE: 'purchaseWrite',
  PURCHASE_EDIT: 'purchaseEdit',
  PURCHASE_DELETE: 'purchaseDelete',
  PURCHASE_REPORT_DOWNLOAD: 'purchaseReportDownload',
  PURCHASE_HISTORY_DISCREPANCY_REPORT: 'purchaseHistoryDiscrepancyReport',
  PURCHASE_VERIFY_MARGIN: 'purchaseVerifyMargin',
  PURCHASE_RETURN_READ: 'purchaseReturnRead',
  PURCHASE_RETURN_WRITE: 'purchaseReturnWrite',
  PURCHASE_RETURN_EDIT: 'purchaseReturnEdit',
  SUPPLIER_READ: 'supplierRead',
  CHEQUE_PAYMENT_READ: 'chequePaymentRead',
  INVENTORY_READ: 'inventoryRead',
  INVENTORY_WRITE: 'inventoryWrite',
  INVENTORY_EDIT: 'inventoryEdit',
  WANTED_NOTE_READ: 'wantedNoteRead',
  EXPENSES_MANAGER_READ: 'expensesManagerRead',
  CASH_BANK_BOOK: 'cashBankBook',
  DASHBOARD_READ: 'dashboardRead',
  STORE_PROFILE_READ: 'storeProfileRead',
  DUNZO_DASHBOARD: 'dunzoDashboard',
  WHOLESALE: 'wholesale',
  BILL_MARGIN: 'staffMargin',
  STOCK_TRANSFER: 'stock_transfer',
  STOCK_TRANSFER_READ: 'stockTransferRead',
  STOCK_TRANSFER_WRITE: 'stockTransferWrite',
  STOCK_TRANSFER_EDIT: 'stockTransferEdit',
  STOCK_TRANSFER_CANCEL: 'stockTransferCancel',
  STOCK_TRANSFER_REJECT: 'stockTransferReject',
  STOCK_TRANSFER_ACCEPT: 'stockTransferAccept',
  STOCK_TRANSFER_BRANCHES_READ: 'stockTransferBranchesRead',
  WHOLESALE_READ: 'wholesaleRead',
  WHOLESALE_WRITE: 'wholesaleWrite',
  WHOLESALE_EDIT: 'wholesaleEdit',
  WHOLESALE_DELETE: 'wholesaleDelete',
  WHOLESALE_RETAILER_READ: 'wholesaleRetailerRead',
  WHOLESALE_RETAILER_WRITE: 'wholesaleRetailerWrite',
  WHOLESALE_RETAILER_EDIT: 'wholesaleRetailerEdit',
  // Config Keys
  ENABLE_BILL_PIN: 'enableBillPin',
  REQUEST_SKU: 'requestSku',
  WMS: 'wms',
  WMS_B2C: 'wmsB2c',
  SHOW_B2C_SALES: 'showB2cSales',
  // GRN
  GRN_QTY_UPDATE: 'grnQtyUpdate',
  ALLOW_UPDATE_GRN: 'allowUpdateGRN',
  ALLOW_DELETE_GRN: 'allowCancelGRN',
  COUPON: 'coupons_feature',
  WHOLESALE_DELIVERY: 'deliveryFlowV2',
  AI_DASHBOARD: 'aiDashboard',
  // Report key Enums
  REPORT_READ: 'allReportRead',
  REPORT_DOWNLOAD: 'allReportDownload',
  ...REPORT_STAFF_ACCESS_READ_KEYS,
  ...REPORT_STAFF_ACCESS_DOWNLOAD_KEYS,
};

// add url and related access control here to block the url directly
export const UrlToAccessControlMap = {
  'bill-history': [ACCESS_CONTROL_KEYS_ENUM.BILL_READ],
  'bill-entry': [ACCESS_CONTROL_KEYS_ENUM.BILL_WRITE],
  'online-orders': [ACCESS_CONTROL_KEYS_ENUM.ONLINE_ORDER_READ],
  customers: [ACCESS_CONTROL_KEYS_ENUM.CUSTOMER_READ],
  'payments-history': [ACCESS_CONTROL_KEYS_ENUM.PAYMENT_READ],
  'sales-return-history': [ACCESS_CONTROL_KEYS_ENUM.SALES_RETURN_READ],
  'sales-return': [ACCESS_CONTROL_KEYS_ENUM.SALES_RETURN_WRITE],
  'purchase-history': [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_READ],
  'purchase-entry': [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_WRITE],
  'purchase-return-history': [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_RETURN_READ],
  'purchase-return': [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_RETURN_WRITE],
  suppliers: [ACCESS_CONTROL_KEYS_ENUM.SUPPLIER_READ],
  'cheque-payment': [ACCESS_CONTROL_KEYS_ENUM.CHEQUE_PAYMENT_READ],
  'wanted-note': [ACCESS_CONTROL_KEYS_ENUM.WANTED_NOTE_READ],
  'manage-expenses': [ACCESS_CONTROL_KEYS_ENUM.EXPENSES_MANAGER_READ],
  dashboard: [ACCESS_CONTROL_KEYS_ENUM.DASHBOARD_READ],
  'store-profile': [ACCESS_CONTROL_KEYS_ENUM.STORE_PROFILE_READ],
  wholesale: [ACCESS_CONTROL_KEYS_ENUM.WHOLESALE],
  'purchase-order': [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_ORDER],
  'analytics-dashboard': [ACCESS_CONTROL_KEYS_ENUM.AI_DASHBOARD],
  'stock-transfer': [
    ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER,
    ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_WRITE,
  ],
  'transfer-details': [
    ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER,
    ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_READ,
  ],
  coupon: [ACCESS_CONTROL_KEYS_ENUM.COUPON],
  branches: [
    ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER,
    ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_BRANCHES_READ,
  ],
  doctors: [ACCESS_CONTROL_KEYS_ENUM.DOCTOR_READ],
  dunzo: [ACCESS_CONTROL_KEYS_ENUM.DUNZO_DASHBOARD],
  requestSku: [ACCESS_CONTROL_KEYS_ENUM.REQUEST_SKU],
  'cash-bank-book': [ACCESS_CONTROL_KEYS_ENUM.CASH_BANK_BOOK],

  // Reports
  'stock-report': [ACCESS_CONTROL_KEYS_ENUM.BATCHWISE_STOCK_READ],
  'opening-stock-report': [ACCESS_CONTROL_KEYS_ENUM.OPENING_STOCK_READ],
  'expiry-report': [ACCESS_CONTROL_KEYS_ENUM.EXPIRY_REPORT_READ],
  'stock-adjustment-report': [ACCESS_CONTROL_KEYS_ENUM.STOCK_ADJUSTMENT_READ],
  'non-moving-items-report': [ACCESS_CONTROL_KEYS_ENUM.NON_MOVING_READ],
  'item-mapping-report': [ACCESS_CONTROL_KEYS_ENUM.ITEM_MAPPING_READ],
  'low-stock-report': [ACCESS_CONTROL_KEYS_ENUM.LOW_STOCK_READ],
  'item-master-report': [ACCESS_CONTROL_KEYS_ENUM.ITEM_MASTER_READ],
  'schedule-report': [ACCESS_CONTROL_KEYS_ENUM.SCHEDULE_REPORT_READ],
  'new-item-report': [ACCESS_CONTROL_KEYS_ENUM.NEW_ITEM_READ],
  'itemwise-stock-report': [ACCESS_CONTROL_KEYS_ENUM.ITEMWISE_REPORT_READ],
  'bounce-item-report': [ACCESS_CONTROL_KEYS_ENUM.BOUNCE_ITEM_READ],
  'stock-audit-report': [ACCESS_CONTROL_KEYS_ENUM.STOCK_AUDIT_READ],
  'enquiry-report': [ACCESS_CONTROL_KEYS_ENUM.ENQUIRY_READ],
  'oversold-report': [ACCESS_CONTROL_KEYS_ENUM.OVERSOLD_REPORT_READ],
  'itemwise-sales-margin-report': [ACCESS_CONTROL_KEYS_ENUM.ITEMWISE_SALES_MARGIN_READ],
  'batchwise-sales-report': [ACCESS_CONTROL_KEYS_ENUM.BATCHWISE_SALES_READ],
  'itemwise-sales-report': [ACCESS_CONTROL_KEYS_ENUM.ITEMWISE_SALES_READ],
  'staffwise-sales-report': [ACCESS_CONTROL_KEYS_ENUM.STAFFWISE_SALES_READ],
  'salesperson-report': [ACCESS_CONTROL_KEYS_ENUM.SALESPERSON_INCENTIVE_READ],
  'shift-management-report': [ACCESS_CONTROL_KEYS_ENUM.SHIFT_MANAGEMENT_READ],
  'batchwise-purchase-report': [ACCESS_CONTROL_KEYS_ENUM.BATCHWISE_PURCHASE_READ],
  'overbought-report': [ACCESS_CONTROL_KEYS_ENUM.OVERBOUGHT_READ],
  'daily-summary-report': [ACCESS_CONTROL_KEYS_ENUM.DAILY_SUMMARY_READ],
  'supplier-due-date-report': [ACCESS_CONTROL_KEYS_ENUM.SUPPLIER_DUE_DATE_READ],
  'gst-report-sales': [ACCESS_CONTROL_KEYS_ENUM.GSTR_SALES_READ],
  'gst-report-purchase': [ACCESS_CONTROL_KEYS_ENUM.GSTR_PURCHASE_READ],
  'gst-report-gstr1': [ACCESS_CONTROL_KEYS_ENUM.GSTR_1_READ],
  'gst-report-gstr2a': [ACCESS_CONTROL_KEYS_ENUM.GSTR_2A_READ],
  'gst-report-gstr3b': [ACCESS_CONTROL_KEYS_ENUM.GSTR_3B_READ],
  'branch-po-report': [ACCESS_CONTROL_KEYS_ENUM.BRANCH_PO_READ],
  'grn-history-report': [ACCESS_CONTROL_KEYS_ENUM.GRN_HISTORY_READ],
  'fkh-report': [ACCESS_CONTROL_KEYS_ENUM.FKH_REPORT_READ],
  'tally-master': [ACCESS_CONTROL_KEYS_ENUM.TALLY_MASTER_READ],
  'tally-transaction': [ACCESS_CONTROL_KEYS_ENUM.TALLY_TRANSACTION_READ],
};

// check function for access control and custom cases to block url
export const checkForAccessControl = () => {
  const path = location.pathname.split('/');
  const accessControlTypeFromUrl =
    UrlToAccessControlMap[path[1] as keyof typeof UrlToAccessControlMap];

  accessControlTypeFromUrl?.map((item) => {
    UserAccessControlData.get(item, true);
  });

  // case for expiry report and other report handling as all have common report path first
  if (path[1] === 'report' && path.length > 2) {
    if (path[2] === 'generated-report') return true;
    UserAccessControlData.get(
      UrlToAccessControlMap[path[2] as keyof typeof UrlToAccessControlMap][0],
      true,
    );
  }

  // case for bill edit and purchase edit when bill entry or purchase entry is enabled
  if (
    (path[1] === 'bill-entry' || path[1] === 'purchase-entry') &&
    path[2]?.length > 0 &&
    path.length == 3
  ) {
    path[1] === 'bill-entry'
      ? UserAccessControlData.get(ACCESS_CONTROL_KEYS_ENUM.BILL_EDIT, true)
      : UserAccessControlData.get(ACCESS_CONTROL_KEYS_ENUM.PURCHASE_EDIT, true);
  }

  // case for sales return edit and purchase return edit when sales return entry or purchase return entry is enabled
  if (
    (path[1] === 'sales-return' || path[1] === 'purchase-return') &&
    path[2]?.length > 0 &&
    location.search === '?type=edit'
  ) {
    path[1] === 'sales-return'
      ? UserAccessControlData.get(ACCESS_CONTROL_KEYS_ENUM.SALES_RETURN_EDIT, true)
      : UserAccessControlData.get(ACCESS_CONTROL_KEYS_ENUM.PURCHASE_RETURN_EDIT, true);
  }

  // case for wholesale sub screens
  if (path[1] === 'wholesale') {
    path[2] === 'bill-entry'
      ? UserAccessControlData.get(ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_WRITE, true)
      : path[2] === 'bill-history'
      ? UserAccessControlData.get(ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_READ, true)
      : null;
  }

  if (path[1] === 'requested-sku') {
    UserAccessControlData.get(ACCESS_CONTROL_KEYS_ENUM.REQUEST_SKU, true);
  }
};

const redirectForAccessControl = (accessKey?: string) => {
  if (!accessKey) return;

  const parentMenu = SIDEBAR_MENU.find(
    (menu) =>
      menu.accessKey === accessKey || menu.items?.some((child) => child.accessKey === accessKey),
  );

  const accessibleChild = parentMenu?.items?.find(
    (child) => !child.accessKey || !UserAccessControlData.get(child.accessKey),
  );

  if (accessibleChild?.url) {
    const targetUrl = `/${accessibleChild.url}`;
    window.history.pushState({}, '', targetUrl);
    window.dispatchEvent(new PopStateEvent('popstate'));
  } else {
    window.location.replace('/status/403');
  }
};

export const findFirstAccessibleUrl = (): string => {
  const accessibleItem = SIDEBAR_MENU.flatMap((menu) => menu.items || []).find((item) => {
    const hasAccess = !item.accessKey || !UserAccessControlData.get(item.accessKey);
    return hasAccess && item.url;
  });
  return accessibleItem ? `/${accessibleItem.url}` : '/status/403';
};

// util to check the data from session details
export const UserAccessControlData = {
  get: (accessKey: string | undefined, redirect = false) => {
    let res = undefined;
    if (accessKey === ACCESS_CONTROL_KEYS_ENUM.REQUEST_SKU) {
      res = StoreUtils.getKeyFromActiveSession(['userData', accessKey ?? '']);
    } else {
      res = StoreUtils.getKeyFromActiveSession(['userData', 'access', accessKey ?? '']);
    }

    // to check onboarded only screens so to block by default

    if (accessKey === ACCESS_CONTROL_KEYS_ENUM.WMS) {
      return !StoreUtils.getKeyFromActiveSession(['config', ACCESS_CONTROL_KEYS_ENUM.WMS]);
    }

    if (accessKey === ACCESS_CONTROL_KEYS_ENUM.GRN_QTY_UPDATE) {
      return !StoreUtils.getKeyFromActiveSession([
        'config',
        ACCESS_CONTROL_KEYS_ENUM.GRN_QTY_UPDATE,
      ]);
    }

    if (accessKey === ACCESS_CONTROL_KEYS_ENUM.ENABLE_SALES_ORDER) {
      return !StoreUtils.getKeyFromActiveSession([
        'config',
        ACCESS_CONTROL_KEYS_ENUM.ENABLE_SALES_ORDER,
      ]);
    }

    if (accessKey == ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_DELIVERY) {
      return !StoreUtils.getKeyFromActiveSession([
        'config',
        ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_DELIVERY,
      ]);
    }

    if (accessKey == ACCESS_CONTROL_KEYS_ENUM.AI_DASHBOARD) {
      return !StoreUtils.getKeyFromActiveSession(['config', ACCESS_CONTROL_KEYS_ENUM.AI_DASHBOARD]);
    }

    if (accessKey === ACCESS_CONTROL_KEYS_ENUM.WMS_B2C) {
      return !StoreUtils.isWmsB2cStore();
    }

    if (accessKey == ACCESS_CONTROL_KEYS_ENUM.COUPON) {
      return !StoreUtils.getKeyFromActiveSession(['config', ACCESS_CONTROL_KEYS_ENUM.COUPON]);
    }

    if (accessKey == ACCESS_CONTROL_KEYS_ENUM.SHOW_B2C_SALES) {
      const showB2cSales = StoreUtils.getKeyFromActiveSession([
        'config',
        ACCESS_CONTROL_KEYS_ENUM.SHOW_B2C_SALES,
      ]);
      return showB2cSales !== undefined ? !showB2cSales : false;
    }

    if (
      accessKey === ACCESS_CONTROL_KEYS_ENUM.WHOLESALE ||
      accessKey === ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER ||
      accessKey === ACCESS_CONTROL_KEYS_ENUM.DUNZO_DASHBOARD ||
      accessKey === ACCESS_CONTROL_KEYS_ENUM.PURCHASE_ORDER ||
      accessKey === ACCESS_CONTROL_KEYS_ENUM.REQUEST_SKU
    ) {
      if (accessKey === ACCESS_CONTROL_KEYS_ENUM.PURCHASE_ORDER) {
        // purchase order restriction is purchaseOrder or stock transfer restriction
        const accessStockTransfer = StoreUtils.getKeyFromActiveSession([
          'userData',
          'access',
          ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER ?? '',
        ]);
        res = !(res === false || accessStockTransfer === false);
      }
      if ((res === undefined || res) && redirect) {
        redirectForAccessControl(accessKey);
        return true;
      }
      if (res === undefined) {
        return true;
      }
      return res;
    }
    if (UserUtils.isStoreAdmin() && accessKey !== ACCESS_CONTROL_KEYS_ENUM.ENABLE_BILL_PIN) {
      return false;
    }
    if (redirect && res) {
      redirectForAccessControl(accessKey);
    }
    return res;
  },
};

// options shown to staff in settings page
export const ACCESS_CONTROLS: {
  [module: string]: {
    [functionality: string]: {
      name: string;
      label: string;
      hideDependencyKey?: string;
    }[];
  };
} = {
  Sales: {
    'Bill Entry': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BILL_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BILL_WRITE,
        label: 'Add',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BILL_EDIT,
        label: 'Edit',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BILL_DELETE,
        label: 'Delete',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BILL_DISCOUNT,
        label: 'Discount',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BILL_WHATSAPP,
        label: 'WhatsApp Share',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BILL_DATE,
        label: 'Bill Date',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BILL_MARGIN,
        label: 'Margin',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.SALE_REPORT_DOWNLOAD,
        label: 'Report',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BILLED_ITEMS_EDIT,
        label: 'Billed Items Edit',
        hideDependencyKey: ACCESS_CONTROL_KEYS_ENUM.BILL_EDIT,
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.CUSTOMER_DETAILS_EDIT,
        label: 'Customer Details Edit',
        hideDependencyKey: ACCESS_CONTROL_KEYS_ENUM.BILL_EDIT,
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BILL_HISTORY_FOOTER_READ,
        label: 'History Footer',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.SALES_PAYMENT_MODE,
        label: 'Payment Mode',
      },
    ],
    'Sales Return': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.SALES_RETURN_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.SALES_RETURN_WRITE,
        label: 'Add',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.SALES_RETURN_EDIT,
        label: 'Edit',
      },
    ],
    'Online Order': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.ONLINE_ORDER_READ,
        label: 'View',
      },
    ],
    Customers: [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.CUSTOMER_READ,
        label: 'View',
      },
    ],
    Doctors: [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.DOCTOR_READ,
        label: 'View',
      },
    ],
    Payment: [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.PAYMENT_READ,
        label: 'View',
      },
    ],
  },
  Purchase: {
    Purchase: [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.PURCHASE_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.PURCHASE_WRITE,
        label: 'Add',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.PURCHASE_EDIT,
        label: 'Edit',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.PURCHASE_DELETE,
        label: 'Delete',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.PURCHASE_REPORT_DOWNLOAD,
        label: 'Report',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.PURCHASE_VERIFY_MARGIN,
        label: 'Verify Margin',
      },
    ],
    'Purchase History': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.PURCHASE_HISTORY_DISCREPANCY_REPORT,
        label: 'Discrepancy Report',
      },
    ],
    'Purchase Return': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.PURCHASE_RETURN_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.PURCHASE_RETURN_WRITE,
        label: 'Add',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.PURCHASE_RETURN_EDIT,
        label: 'Edit',
      },
    ],
    Suppliers: [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.SUPPLIER_READ,
        label: 'View',
      },
    ],
    'Cheque Payment': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.CHEQUE_PAYMENT_READ,
        label: 'View',
      },
    ],
    'Wanted Note': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.WANTED_NOTE_READ,
        label: 'View',
      },
    ],
  },
  Inventory: {
    Inventory: [
      { name: ACCESS_CONTROL_KEYS_ENUM.INVENTORY_READ, label: 'View' },
      { name: ACCESS_CONTROL_KEYS_ENUM.INVENTORY_WRITE, label: 'Add' },
      { name: ACCESS_CONTROL_KEYS_ENUM.INVENTORY_EDIT, label: 'Edit' },
    ],
  },
  'Stock Transfer': {
    'Stock Transfer': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_WRITE,
        label: 'Add',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_EDIT,
        label: 'Edit',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_CANCEL,
        label: 'Cancel',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_ACCEPT,
        label: 'Accept',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_REJECT,
        label: 'Reject',
      },
    ],
    Branches: [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_BRANCHES_READ,
        label: 'View',
      },
    ],
  },
  Wholesale: {
    Bill: [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_WRITE,
        label: 'Add',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_EDIT,
        label: 'Edit',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_DELETE,
        label: 'Delete',
      },
    ],
    Retailers: [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_RETAILER_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_RETAILER_WRITE,
        label: 'Add',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_RETAILER_EDIT,
        label: 'Edit',
      },
    ],
  },
  Reports: {
    'Apply All': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.REPORT_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.REPORT_DOWNLOAD,
        label: 'Download',
      },
    ],
    // Stock Reports
    'Batchwise Stock Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BATCHWISE_STOCK_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BATCHWISE_STOCK_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Expiry Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.EXPIRY_REPORT_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.EXPIRY_REPORT_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Stock Adjustment': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.STOCK_ADJUSTMENT_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.STOCK_ADJUSTMENT_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Non Moving Items': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.NON_MOVING_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.NON_MOVING_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Item Mapping': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.ITEM_MAPPING_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.ITEM_MAPPING_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Low Stock': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.LOW_STOCK_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.LOW_STOCK_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Item Master Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.ITEM_MASTER_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.ITEM_MASTER_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Schedule H/H1/X/G Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.SCHEDULE_REPORT_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.SCHEDULE_REPORT_DOWNLOAD,
        label: 'Download',
      },
    ],
    'New Item Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.NEW_ITEM_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.NEW_ITEM_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Itemwise Stock Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.ITEMWISE_REPORT_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.ITEMWISE_REPORT_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Bounce Item Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BOUNCE_ITEM_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BOUNCE_ITEM_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Stock Audit Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.STOCK_AUDIT_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.STOCK_AUDIT_DOWNLOAD,
        label: 'Download',
      },
    ],
    // Stock Reports
    'Opening Stock Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.OPENING_STOCK_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.OPENING_STOCK_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Enquiry Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.ENQUIRY_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.ENQUIRY_DOWNLOAD,
        label: 'Download',
      },
    ],
    // Sales report
    'Oversold Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.OVERSOLD_REPORT_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.OVERSOLD_REPORT_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Itemwise Sales Margin': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.ITEMWISE_SALES_MARGIN_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.ITEMWISE_SALES_MARGIN_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Batchwise Sales Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BATCHWISE_SALES_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BATCHWISE_SALES_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Itemwise Sales Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.ITEMWISE_SALES_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.ITEMWISE_SALES_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Staffwise Sales Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.STAFFWISE_SALES_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.STAFFWISE_SALES_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Salesperson Incentive Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.SALESPERSON_INCENTIVE_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.SALESPERSON_INCENTIVE_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Shift Management Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.SHIFT_MANAGEMENT_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.SHIFT_MANAGEMENT_DOWNLOAD,
        label: 'Download',
      },
    ],
    // Purchases report
    'Batchwise Purchase Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BATCHWISE_PURCHASE_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BATCHWISE_PURCHASE_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Overbought Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.OVERBOUGHT_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.OVERBOUGHT_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Daily Summary Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.DAILY_SUMMARY_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.DAILY_SUMMARY_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Supplier Due Date Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.SUPPLIER_DUE_DATE_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.SUPPLIER_DUE_DATE_DOWNLOAD,
        label: 'Download',
      },
    ],
    // GST reports
    'GSTR Sales': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.GSTR_SALES_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.GSTR_SALES_DOWNLOAD,
        label: 'Download',
      },
    ],
    'GSTR Purchase': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.GSTR_PURCHASE_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.GSTR_PURCHASE_DOWNLOAD,
        label: 'Download',
      },
    ],
    'GSTR-1 Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.GSTR_1_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.GSTR_1_DOWNLOAD,
        label: 'Download',
      },
    ],
    'GSTR-2A Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.GSTR_2A_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.GSTR_2A_DOWNLOAD,
        label: 'Download',
      },
    ],
    'GSTR-3B Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.GSTR_3B_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.GSTR_3B_DOWNLOAD,
        label: 'Download',
      },
    ],
    // WMS Reports
    'Branch PO Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BRANCH_PO_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.BRANCH_PO_DOWNLOAD,
        label: 'Download',
      },
    ],
    'GRN History Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.GRN_HISTORY_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.GRN_HISTORY_DOWNLOAD,
        label: 'Download',
      },
    ],
    'FKH Report': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.FKH_REPORT_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.FKH_REPORT_DOWNLOAD,
        label: 'Download',
      },
    ],
    // Tally Reports
    'Tally Master': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.TALLY_MASTER_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.TALLY_MASTER_DOWNLOAD,
        label: 'Download',
      },
    ],
    'Tally Transaction': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.TALLY_TRANSACTION_READ,
        label: 'View',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.TALLY_TRANSACTION_DOWNLOAD,
        label: 'Download',
      },
    ],
  },

  GRN: {
    'GRN History': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.ALLOW_UPDATE_GRN,
        label: 'Update',
      },
      {
        name: ACCESS_CONTROL_KEYS_ENUM.ALLOW_DELETE_GRN,
        label: 'Cancel',
      },
    ],
  },

  Others: {
    'Expenses Manager': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.EXPENSES_MANAGER_READ,
        label: 'View',
      },
    ],

    'Store Profile': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.STORE_PROFILE_READ,
        label: 'View',
      },
    ],

    'Cash & Bank Book': [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.CASH_BANK_BOOK,
        label: 'View',
      },
    ],
    Dashboard: [
      {
        name: ACCESS_CONTROL_KEYS_ENUM.DASHBOARD_READ,
        label: 'View',
      },
    ],
  },
};

// dependency between different access control option within a page
export const DependentAccessControl = {
  [ACCESS_CONTROL_KEYS_ENUM.BILL_EDIT]: {
    // type 1 are for access control that are dependent variable and no one depends on them for example: edit, delete
    dependentType: 1,
    dependency: [
      ACCESS_CONTROL_KEYS_ENUM.BILL_READ,
      ACCESS_CONTROL_KEYS_ENUM.BILL_WRITE,
      ACCESS_CONTROL_KEYS_ENUM.BILLED_ITEMS_EDIT,
      ACCESS_CONTROL_KEYS_ENUM.CUSTOMER_DETAILS_EDIT,
    ],
  },
  [ACCESS_CONTROL_KEYS_ENUM.BILL_READ]: {
    // type 2 are for access control that are independent variable but some variable depends on them
    // for example read, write is independent but edit, delete depends on them
    dependentType: 2,
    dependency: [
      ACCESS_CONTROL_KEYS_ENUM.BILL_EDIT,
      ACCESS_CONTROL_KEYS_ENUM.BILL_DELETE,
      ACCESS_CONTROL_KEYS_ENUM.BILLED_ITEMS_EDIT,
      ACCESS_CONTROL_KEYS_ENUM.CUSTOMER_DETAILS_EDIT,
    ],
  },
  [ACCESS_CONTROL_KEYS_ENUM.BILL_WRITE]: {
    dependentType: 2,
    dependency: [
      ACCESS_CONTROL_KEYS_ENUM.BILL_EDIT,
      ACCESS_CONTROL_KEYS_ENUM.BILL_DELETE,
      ACCESS_CONTROL_KEYS_ENUM.BILL_DISCOUNT,
      ACCESS_CONTROL_KEYS_ENUM.BILLED_ITEMS_EDIT,
      ACCESS_CONTROL_KEYS_ENUM.CUSTOMER_DETAILS_EDIT,
    ],
  },
  [ACCESS_CONTROL_KEYS_ENUM.BILL_DELETE]: {
    dependentType: 1,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.BILL_READ, ACCESS_CONTROL_KEYS_ENUM.BILL_WRITE],
  },
  [ACCESS_CONTROL_KEYS_ENUM.BILL_DISCOUNT]: {
    dependentType: 1,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.BILL_WRITE],
  },
  [ACCESS_CONTROL_KEYS_ENUM.BILLED_ITEMS_EDIT]: {
    dependentType: 1,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.BILL_EDIT, ACCESS_CONTROL_KEYS_ENUM.BILL_DISCOUNT],
  },
  [ACCESS_CONTROL_KEYS_ENUM.CUSTOMER_DETAILS_EDIT]: {
    dependentType: 1,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.BILL_EDIT],
  },
  [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_WRITE]: {
    dependentType: 2,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_EDIT, ACCESS_CONTROL_KEYS_ENUM.PURCHASE_DELETE],
  },
  [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_READ]: {
    dependentType: 2,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_EDIT, ACCESS_CONTROL_KEYS_ENUM.PURCHASE_DELETE],
  },
  [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_EDIT]: {
    dependentType: 1,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_READ, ACCESS_CONTROL_KEYS_ENUM.PURCHASE_WRITE],
  },
  [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_DELETE]: {
    dependentType: 1,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_READ, ACCESS_CONTROL_KEYS_ENUM.PURCHASE_WRITE],
  },
  [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_RETURN_WRITE]: {
    dependentType: 2,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_RETURN_EDIT],
  },
  [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_RETURN_READ]: {
    dependentType: 2,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_RETURN_EDIT],
  },
  [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_RETURN_EDIT]: {
    dependentType: 1,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.PURCHASE_RETURN_READ],
  },
  [ACCESS_CONTROL_KEYS_ENUM.SALES_RETURN_WRITE]: {
    dependentType: 2,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.SALES_RETURN_EDIT],
  },
  [ACCESS_CONTROL_KEYS_ENUM.SALES_RETURN_READ]: {
    dependentType: 2,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.SALES_RETURN_EDIT],
  },
  [ACCESS_CONTROL_KEYS_ENUM.SALES_RETURN_EDIT]: {
    dependentType: 1,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.SALES_RETURN_READ],
  },
  [ACCESS_CONTROL_KEYS_ENUM.INVENTORY_WRITE]: {
    dependentType: 2,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.INVENTORY_EDIT],
  },
  [ACCESS_CONTROL_KEYS_ENUM.INVENTORY_READ]: {
    dependentType: 2,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.INVENTORY_EDIT],
  },
  [ACCESS_CONTROL_KEYS_ENUM.INVENTORY_EDIT]: {
    dependentType: 1,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.INVENTORY_READ, ACCESS_CONTROL_KEYS_ENUM.INVENTORY_WRITE],
  },
  [ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_READ]: {
    dependentType: 2,
    dependency: [
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_REJECT,
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_ACCEPT,
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_EDIT,
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_CANCEL,
    ],
  },
  [ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_WRITE]: {
    dependentType: 2,
    dependency: [
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_REJECT,
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_ACCEPT,
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_EDIT,
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_CANCEL,
    ],
  },
  [ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_EDIT]: {
    dependentType: 1,
    dependency: [
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_WRITE,
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_READ,
    ],
  },
  [ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_CANCEL]: {
    dependentType: 1,
    dependency: [
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_WRITE,
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_READ,
    ],
  },
  [ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_ACCEPT]: {
    dependentType: 1,
    dependency: [
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_WRITE,
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_READ,
    ],
  },
  [ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_REJECT]: {
    dependentType: 1,
    dependency: [
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_WRITE,
      ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER_READ,
    ],
  },
  [ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_READ]: {
    dependentType: 2,
    dependency: [
      ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_EDIT,
      ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_DELETE,
    ],
  },
  [ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_WRITE]: {
    dependentType: 2,
    dependency: [
      ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_EDIT,
      ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_DELETE,
    ],
  },
  [ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_EDIT]: {
    dependentType: 1,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_READ, ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_WRITE],
  },
  [ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_DELETE]: {
    dependentType: 1,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_READ, ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_WRITE],
  },
  [ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_RETAILER_WRITE]: {
    dependentType: 2,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_RETAILER_EDIT],
  },
  [ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_RETAILER_READ]: {
    dependentType: 2,
    dependency: [ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_RETAILER_EDIT],
  },
  [ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_RETAILER_EDIT]: {
    dependentType: 1,
    dependency: [
      ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_RETAILER_WRITE,
      ACCESS_CONTROL_KEYS_ENUM.WHOLESALE_RETAILER_READ,
    ],
  },
};

// when any stores are not onboarded for particular feature
// add key here to not show that tab in staff settings
export const STAFF_SETTING_HIDE = {
  'Stock Transfer': ACCESS_CONTROL_KEYS_ENUM.STOCK_TRANSFER,
  Wholesale: ACCESS_CONTROL_KEYS_ENUM.WHOLESALE,
  GRN: ACCESS_CONTROL_KEYS_ENUM.GRN_QTY_UPDATE,
};

export const WMS_STAFF_ACCESS_CONTROL = ['Branch PO Report', 'GRN History Report'];
export const TALLY_STAFF_ACCESS_CONTROL = ['Tally Master', 'Tally Transaction'];
